import classNames from "classnames"
import isEmpty from "lodash.isempty"
import debounce from "lodash.debounce"
import { useCallback } from "react"

import { Icon } from "web/components"
import useDropDownMenu from "web/hooks/behaviour/useDropDownMenu"
import { formatValue } from "web/services/format"

import { EditSpacialTypeDistanceConditionDropDown } from "./DropDowns"
import Operator from "./Operator"

function getDisplayText(value) {
  if (isEmpty(value)) {
    return "All"
  }

  return formatValue(value)
}

function CloseButton({ onClick }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleClose = useCallback(
    debounce(onClick, Infinity, {
      leading: true,
    }),
    []
  )

  return <Icon name="x-mark" onClick={handleClose} width="15px" height="15px" />
}

export default function SpatialTypeDistanceConditionPill({
  condition,
  onChange,
  onDelete,
}) {
  const id = `filter-condition-${condition.id}`
  const {
    DropDownMenu,
    menuVisible: dropDownOpen,
    toggleMenu: toggleDropDown,
  } = useDropDownMenu({
    triggerElementId: id,
  })

  const { value, operator = "" } = condition

  const isUsed = !isEmpty(value)

  const classes = classNames(
    "flex text-sm border items-center rounded-full ml-2 mt-2 py-2 px-2 w-full md:w-auto shadow-sm hover:bg-primary-10 hover:border-blue-300 cursor-pointer",
    {
      "bg-primary-10 border-blue-100 text-primary-1": isUsed,
      "bg-white border-neutral-9 text-neutral-2": !isUsed,
    }
  )

  async function handleChange(updatedConditionValue) {
    onChange(condition, updatedConditionValue)
    toggleDropDown()
  }

  function handleClear(defaultCondition = condition) {
    toggleDropDown()
    onChange(condition, { ...defaultCondition, value: {} })
  }

  function handleDelete() {
    onDelete(condition)
  }

  return (
    <>
      <div
        key={id}
        id={id}
        className={classes}
        data-testid="filter-condition-distance"
      >
        <CloseButton onClick={handleDelete} />
        <button
          onClick={toggleDropDown}
          data-testid="button-filter-condition-distance"
          className="flex flex-grow pl-2 focus:outline-none"
        >
          <span className="flex-grow pr-4 font-bold">Distance</span>
          <span className="pr-2">
            {!isEmpty(value) && (
              <Operator operator={operator} disableEquals={true} />
            )}
            <span className="ml-1">{getDisplayText(value, operator)}</span>
          </span>
          <Icon name="chevron-down" />
        </button>
      </div>
      {dropDownOpen && (
        <DropDownMenu>
          <EditSpacialTypeDistanceConditionDropDown
            condition={condition}
            onCancel={toggleDropDown}
            onChange={handleChange}
            onClear={handleClear}
          />
        </DropDownMenu>
      )}
    </>
  )
}
